module.exports = __webpack_public_path__ + "static/media/mdata_logo.ae0be8ac.png";